import React from 'react';
import { X, Camera } from 'lucide-react';

const VirtualTryOn = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl max-w-md w-full p-6 text-center">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500">
          <X className="w-6 h-6" />
        </button>
        
        <div className="mb-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Camera className="w-10 h-10 text-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Virtual Try-On</h2>
          <p className="text-gray-600 mb-4">
            Coming Soon!
          </p>
          <p className="text-sm text-gray-500">
            Our virtual try-on feature is currently being improved to give you a better experience. 
            In the meantime, visit us in store to try on our beautiful collection of frames!
          </p>
        </div>
        
        <div className="space-y-3">
          <a 
            href="/contact#contact-form" 
            className="block w-full bg-red-600 text-white py-3 rounded-lg font-medium hover:bg-red-700 transition-colors"
            onClick={onClose}
          >
            Book an Appointment
          </a>
          <button 
            onClick={onClose}
            className="block w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default VirtualTryOn;
